// Dedicated SEO industry landing pages.
const A = "https://customer-assets.emergentagent.com/job_drone-survey-pro-4/artifacts";
const U = "https://images.unsplash.com";

export const industryPages = [
  {
    slug: "construction",
    nav: "Construction",
    title: "Drone Services for Construction | Progress Monitoring India — Snesar",
    description:
      "Drone services for construction in India — progress monitoring, site surveys, aerial photography & videography, volume analysis and time-lapse documentation for developers and contractors.",
    keywords:
      "Construction Drone Services, Drone Construction Monitoring, Construction Progress Monitoring, Construction Site Survey, Construction Aerial Photography, Time Lapse Construction, Volume Analysis",
    hero: `${A}/ks8q0yor_DJI_0099%20-%20Copy.webp`,
    heroFit: "object-cover",
    h1: "Drone Services for Construction",
    lead:
      "From groundbreaking to handover, we give construction teams a consistent aerial record — progress monitoring, site surveys and volumetrics that keep projects on track.",
    sections: [
      { heading: "How we help construction projects", points: ["Weekly & monthly progress monitoring", "Fixed-GPS comparison imagery", "Earthwork & stockpile volume analysis", "Time-lapse documentation", "Client reporting dashboards"] },
      { heading: "Who we work with", points: ["Developers & builders", "EPC contractors", "Project management consultants", "Government infrastructure agencies"] },
    ],
    relatedServices: ["construction-progress-monitoring", "drone-photography", "drone-videography"],
  },
  {
    slug: "railway",
    nav: "Railway",
    title: "Drone Services for Railways | Railway Survey & Monitoring — Snesar",
    description:
      "Railway drone services in India — corridor survey, LiDAR mapping, construction monitoring and thermal inspection of railway infrastructure and overhead lines.",
    keywords:
      "Railway Drone Survey, Railway Construction Monitoring, Metro Rail Drone Survey, Railway Corridor Survey, Railway LiDAR Survey, Railway Infrastructure Inspection",
    hero: `${A}/21b19545_WhatsApp%20Image%202025-10-29%20at%2010.06.48%20AM.jpeg`,
    heroFit: "object-cover",
    h1: "Drone Services for Railways",
    lead:
      "GPS-referenced corridor mapping, construction monitoring and thermal inspection for railway and metro projects — including challenging ghat sections.",
    sections: [
      { heading: "Railway capabilities", points: ["Corridor survey & alignment mapping", "LiDAR terrain modelling", "Construction progress monitoring", "Overhead traction thermal inspection", "Bridge construction monitoring"] },
      { heading: "Proven experience", points: ["Central Railway thermal powerline inspection across Lonavala & Igatpuri ghats"] },
    ],
    relatedServices: ["railway-survey", "lidar-survey", "drone-inspection"],
  },
  {
    slug: "airport",
    nav: "Airport",
    title: "Drone Services for Airports | Airport Construction Monitoring — Snesar",
    description:
      "Airport drone services in India — runway survey, aviation infrastructure survey and long-term airport construction progress monitoring and documentation.",
    keywords:
      "Airport Drone Survey, Airport Construction Monitoring, Runway Survey, Aviation Infrastructure Survey, Airport Progress Photography",
    hero: `${A}/wc451ao8_DJI_1025%20%281%29.webp`,
    heroFit: "object-cover",
    h1: "Drone Services for Airports",
    lead:
      "Long-term aerial documentation and survey for airports and aviation infrastructure — proven over four years at Navi Mumbai International Airport.",
    sections: [
      { heading: "Airport capabilities", points: ["Runway & apron survey", "Aviation infrastructure survey", "Terminal progress photography & videography", "Time-lapse construction documentation", "Scheduled progress reporting"] },
      { heading: "Flagship experience", points: ["4 years of continuous monitoring at Navi Mumbai International Airport (2022–2026)"] },
    ],
    relatedServices: ["airport-construction-monitoring", "construction-progress-monitoring", "drone-photography"],
  },
  {
    slug: "mining",
    nav: "Mining",
    title: "Drone Survey for Mining & Quarry | Volume Analysis India — Snesar",
    description:
      "Mining drone survey in India — high-accuracy stockpile and volume analysis, mine planning, quarry surveys and periodic topographic mapping.",
    keywords:
      "Mining Drone Survey, Drone Mine Survey, Drone Quarry Survey, Stockpile Volume Survey, Mine Planning Drone, Earthwork Volume Calculation",
    hero: `${A}/z776k8ug_images%20%281%29.jpg`,
    heroFit: "object-cover",
    h1: "Drone Survey for Mining & Quarrying",
    lead:
      "Fast, safe and accurate aerial surveys for mines and quarries — precise stockpile volumes, extraction tracking and mine planning data.",
    sections: [
      { heading: "Mining survey services", points: ["Stockpile volume calculation", "Cut & fill / earthwork analysis", "Periodic topographic mapping", "Haul-road & pit monitoring", "GIS-ready deliverables"] },
    ],
    gallery: [
      { url: `${A}/z776k8ug_images%20%281%29.jpg`, label: "Open-Pit Volume & Contour Mapping" },
      { url: `${A}/wmdnnv5z_Drone-Survey-Mines-Droid-Mining-Solutions.webp`, label: "LiDAR Point Cloud — Mine Terrain" },
      { url: `${A}/grhqax9j_Screenshot%202026-07-08%20150135.webp`, label: "Detailed Survey Deliverable" },
    ],
    relatedServices: ["drone-land-survey", "lidar-survey", "construction-progress-monitoring"],
  },
  {
    slug: "solar",
    nav: "Solar",
    title: "Drone Inspection for Solar Plants | Thermal Solar Survey — Snesar",
    description:
      "Solar farm drone services in India — aerial thermal inspection, module fault detection, site survey and construction monitoring for solar power plants.",
    keywords:
      "Solar Plant Inspection, Solar Farm Survey, Solar Thermal Drone Inspection, Solar Panel Hotspot Detection, Solar Construction Monitoring",
    hero: `${U}/photo-1509391366360-2e959784a276?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85`,
    heroFit: "object-cover",
    h1: "Drone Services for Solar Plants",
    lead:
      "Aerial thermal inspection and survey for solar power plants — pinpointing underperforming modules and accelerating O&M across large sites.",
    sections: [
      { heading: "Solar plant services", points: ["Thermal module hotspot detection", "String & panel fault mapping", "Site survey & layout planning", "Construction progress monitoring", "Performance & defect reporting"] },
    ],
    relatedServices: ["drone-inspection", "powerline-inspection", "drone-land-survey"],
  },
  {
    slug: "oil-gas",
    nav: "Oil & Gas",
    title: "Drone Services for Oil & Gas | Pipeline Inspection India — Snesar",
    description:
      "Oil & gas drone services in India — pipeline monitoring, right-of-way inspection, thermal leak-risk assessment and facility inspection with safety documentation.",
    keywords:
      "Oil and Gas Survey, Pipeline Inspection, Gas Pipeline Drone Inspection, Right of Way Inspection, Thermal Pipeline Inspection, Refinery Inspection",
    hero: `${A}/gw30j23r_b0f383fe-d9cb-4b61-98cc-08c612d05d19.webp`,
    heroFit: "object-cover",
    h1: "Drone Services for Oil & Gas",
    lead:
      "Safe aerial monitoring and thermal inspection of pipelines, right-of-way corridors and facilities — reducing risk and downtime.",
    sections: [
      { heading: "Oil & gas services", points: ["Pipeline & ROW monitoring", "Thermal leak-risk assessment", "Facility & tank inspection", "Corridor survey & mapping", "Safety documentation"] },
    ],
    relatedServices: ["drone-inspection", "powerline-inspection", "lidar-survey"],
  },
  {
    slug: "industrial-plants",
    nav: "Industrial Plants",
    title: "Drone Services for Industrial Plants | Inspection & Survey — Snesar",
    description:
      "Industrial plant drone services in India — facility inspection, thermal analysis, stack & structure surveys and construction monitoring without downtime.",
    keywords:
      "Industrial Inspection, Industrial Drone Inspection, Factory Inspection, Plant Inspection Drone, Thermal Industrial Inspection, Industrial Site Survey",
    hero: `${A}/cff8gkrz_Screenshot%202026-07-08%20141649.webp`,
    heroFit: "object-cover",
    h1: "Drone Services for Industrial Plants",
    lead:
      "High-resolution and thermal inspection of industrial facilities and equipment — safer, faster and without shutting down operations.",
    sections: [
      { heading: "Industrial services", points: ["Facility & equipment inspection", "Thermal hotspot analysis", "Stack & structure surveys", "Construction & expansion monitoring", "Condition & defect reporting"] },
    ],
    relatedServices: ["drone-inspection", "construction-progress-monitoring", "drone-photography"],
  },
  {
    slug: "real-estate",
    nav: "Real Estate",
    title: "Drone Services for Real Estate | Property Marketing India — Snesar",
    description:
      "Real estate drone services in India — property showcase videos, aerial photography, floor-wise 360° views, lifestyle films and township marketing content.",
    keywords:
      "Real Estate Drone Photography, Real Estate Drone Videography, Property Drone Shoot, Township Drone Video, Floor Wise 360 View, Construction Marketing Video",
    hero: `${U}/photo-1499669404910-ba8b35824a3c?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85`,
    heroFit: "object-cover",
    h1: "Drone Services for Real Estate",
    lead:
      "Cinematic aerial marketing that sells faster — property showcases, location-advantage films and floor-wise 360° views for residential and commercial projects.",
    sections: [
      { heading: "Real estate services", points: ["Property showcase videos & photography", "Location advantage & lifestyle films", "Floor-wise 360° views & virtual tours", "Township & luxury project videos", "Social media promotional content"] },
    ],
    relatedServices: ["real-estate-drone-services", "drone-photography", "drone-videography"],
  },
  {
    slug: "ports",
    nav: "Ports",
    title: "Drone Services for Ports & Harbours | Survey & Monitoring — Snesar",
    description:
      "Port and harbour drone services in India — site survey, construction monitoring, stockpile volume analysis and aerial documentation of port infrastructure.",
    keywords:
      "Port Survey, Port Drone Survey, Harbour Survey, Port Construction Monitoring, Port Stockpile Volume, Coastal Infrastructure Survey",
    hero: `${U}/photo-1639037179118-d1a475030792?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85`,
    heroFit: "object-cover",
    h1: "Drone Services for Ports & Harbours",
    lead:
      "Aerial survey, volumetrics and construction monitoring for ports, harbours and coastal infrastructure at scale.",
    sections: [
      { heading: "Port services", points: ["Site & topographic survey", "Stockpile & cargo volume analysis", "Construction progress monitoring", "Infrastructure inspection", "Aerial documentation"] },
    ],
    relatedServices: ["drone-land-survey", "construction-progress-monitoring", "drone-inspection"],
  },
  {
    slug: "smart-city",
    nav: "Smart City",
    title: "Drone Services for Smart Cities | GIS Mapping India — Snesar",
    description:
      "Smart city drone services in India — GIS mapping, urban topographic survey, LiDAR, asset inspection and geo-tagged documentation for urban development projects.",
    keywords:
      "Smart City Survey, Smart City Drone Mapping, Urban GIS Mapping, City Topographic Survey, Urban Infrastructure Survey, Geo Tagged Survey",
    hero: `${U}/photo-1470723710355-95304d8aece4?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85`,
    heroFit: "object-cover",
    h1: "Drone Services for Smart Cities",
    lead:
      "Accurate geospatial data for urban planning — GIS mapping, LiDAR terrain models and asset documentation that power smart-city projects.",
    sections: [
      { heading: "Smart city services", points: ["GIS mapping & geospatial data", "Urban topographic & LiDAR survey", "Utility & asset inspection", "Geo-tagged documentation", "Development progress monitoring"] },
    ],
    relatedServices: ["drone-land-survey", "lidar-survey", "drone-inspection"],
  },
  {
    slug: "highways",
    nav: "Highways",
    title: "Drone Services for Highways | NHAI Road Survey India — Snesar",
    description:
      "Highway drone services in India — road corridor survey, LiDAR mapping, NHAI documentation, geo-tagged imagery and construction progress monitoring.",
    keywords:
      "Highway Drone Survey, Road Survey Using Drone, Expressway Survey, NHAI Drone Survey, Highway Corridor Survey, Highway Construction Monitoring",
    hero: `${U}/photo-1470723710355-95304d8aece4?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85`,
    heroFit: "object-cover",
    h1: "Drone Services for Highways",
    lead:
      "GPS-referenced corridor mapping and progress monitoring for highways and expressways — from DPR-stage survey to construction handover.",
    sections: [
      { heading: "Highway services", points: ["Road corridor & topographic survey", "LiDAR terrain modelling", "NHAI documentation & geo-tagged imagery", "Construction progress monitoring", "Volume & earthwork analysis"] },
    ],
    relatedServices: ["drone-land-survey", "lidar-survey", "railway-survey"],
  },
  {
    slug: "data-centres",
    nav: "Data Centres",
    title: "Drone Services for Data Centres | Construction Monitoring — Snesar",
    description:
      "Data centre drone services in India — construction progress monitoring, site survey, aerial photography and documentation for hyperscale and colocation facilities.",
    keywords:
      "Data Centre Construction Monitoring, Data Center Drone Survey, Data Centre Progress Photography, Hyperscale Construction Monitoring, Facility Construction Documentation",
    hero: `${A}/fz7tjc8n_DSC03114.webp`,
    heroFit: "object-cover",
    h1: "Drone Services for Data Centres",
    lead:
      "Consistent construction progress documentation and survey for data centre developments — keeping fast-track builds transparent and on schedule.",
    sections: [
      { heading: "Data centre services", points: ["Construction progress monitoring", "Site & topographic survey", "Aerial & interior documentation", "Time-lapse construction records", "High-resolution progress reports"] },
    ],
    relatedServices: ["construction-progress-monitoring", "drone-photography", "drone-inspection"],
  },
];

export const getIndustryBySlug = (slug) =>
  industryPages.find((p) => p.slug === slug);
